import { Check } from 'lucide-react-native';
import * as CheckboxPrimitive from '@/lib/rn-primatives/checkbox';
import { cn } from '@/lib/utils';
import * as React from 'react';
import { Platform } from 'react-native';
import colors from '@/constants/Colors';

const CustomCheckbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => {
  return (
    <CheckboxPrimitive.Root
      ref={ref}
      className={cn(
        'web:peer h-5 w-5 native:h-[24] native:w-[24] shrink-0 rounded-sm native:rounded border-2',
        className
      )}
      style={{
        backgroundColor: props.checked ? colors.primary : 'transparent',
        borderColor: props.checked ? colors.primary : '#666',
      }}
      {...props}
    >
      <CheckboxPrimitive.Indicator className={cn('items-center justify-center h-full w-full')}>
        <Check
          size={14}
          strokeWidth={Platform.OS === 'web' ? 2.5 : 3.5}
          color={colors.accent}
        />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
});
CustomCheckbox.displayName = 'CustomCheckbox';

export { CustomCheckbox };

